import {
  BoxProps,
  Flex,
  FlexProps,
  HStack,
  IconButton,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  useColorMode,
  Divider,
  Image,
} from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { FiMenu } from 'react-icons/fi';
import { BsCreditCardFill, BsMoonStarsFill, BsSun } from 'react-icons/bs';
import URLConfig from '../../config/urls/url.config';
import { ChakraComponents as CC } from '../../modules/core/lib/chakra';
import { Link } from 'react-router-dom';
import SidebarNav from './SidebarNav';
import Header from '../Header';
import BankInfo from '@Layouts/BankInfo';

export interface LinkItemProps {
  level: number;
  name: string;
  link?: string;
  icon?: IconType;
  subMenu?: LinkItemProps[];
}

interface SidebarProps extends BoxProps {
  onClose: () => void;
  LinkItems: Array<LinkItemProps>;
}

export default function AppSidebar({
  LinkItems,
  onClose,
  ...rest
}: SidebarProps) {
  return (
    <CC.Box
      overflow={'auto'}
      transition="3s ease"
      bg={CC.useColorModeValue('white', 'gray.800')}
      borderRight="1px"
      borderRightColor={CC.useColorModeValue(
        'gray.200',
        'gray.800'
      )}
      w={{ base: 'full', md: 64 }}
      pos="fixed"
      h="full"
      {...rest}
    >
      <CC.Flex
        h="16"
        alignItems="center"
        mx="8"
        justifyContent="space-between"
      >
        <CC.Text
          fontSize="2xl"
          fontFamily="arial"
          fontWeight="bold"
        >
          <Link to={URLConfig.ROOT}>
            <Image
              height={'50px'}
              objectFit='contain'
              src='/assets/images/brand/greatpay.png'
              alt='GreatPay Logo'
            />
          </Link>
        </CC.Text>
        <CC.CloseButton
          display={{ base: 'flex', md: 'none' }}
          onClick={onClose}
          color={useColorModeValue('gray.800', 'white')}
        />
      </CC.Flex>
        <Divider mb={"3%"} />
        <SidebarNav menuLinkData={LinkItems} />
    </CC.Box>
  );
}

export interface MobileProps extends FlexProps {
  onOpen: () => void;
}

export const MobileNav = ({ onOpen, ...rest }: MobileProps) => {
  const { colorMode, toggleColorMode } = useColorMode();
  return (
    <Flex
      ml={{ base: 0, md: 64 }}
      px={{ base: 4, md: 4 }}
      height="16"
      alignItems="center"
      bg={useColorModeValue('white', 'gray.900')}
      borderBottomWidth="1px"
      borderBottomColor={useColorModeValue('gray.200', 'gray.700')}
      justifyContent={{ base: 'space-between', md: 'flex-end' }}
      {...rest}
    >
      <IconButton
        display={{ base: 'flex', md: 'none' }}
        onClick={onOpen}
        variant="outline"
        aria-label="open menu"
        icon={<FiMenu />}
      />

      <Text
        display={{ base: 'flex', md: 'none' }}
        fontSize="xl"
        fontFamily="monospace"
        fontWeight="bold"
      >
        GreatPay
      </Text>

      <HStack spacing={{ base: '0', md: '6' }}>
        <BankInfo />
        <IconButton
          size="lg"
          variant="ghost"
          aria-label="open menu"
          onClick={toggleColorMode}
          icon={colorMode === 'light' ? <BsMoonStarsFill /> : <BsSun />}
        />
        <Flex alignItems={'center'}>
          <Menu>
            <MenuButton
              py={2}
              transition="all 0.3s"
              _focus={{ boxShadow: 'none' }}
            >
              <Header />
            </MenuButton>
            <MenuList>
              <Link to={URLConfig.HOME.PROFILE}>
                <MenuItem>Profile</MenuItem>
              </Link>
              <MenuDivider />

              <Link to={URLConfig.ROOT}>
                <MenuItem>Sign out</MenuItem>
              </Link>
            </MenuList>
          </Menu>
        </Flex>
      </HStack>
    </Flex>
  );
};
